import React from "react";
import { Image } from "antd";
import emptyPage from "../assets/media/emptyPage.png";

const EmptyPage = () => {
  return <Image src={emptyPage} preview={false} />;
};

export default EmptyPage;
